import styled from "styled-components";
import { useController } from "react-hook-form";
import {
  FaEgg,
  FaFish,
  FaCheese,
  FaSeedling,
  FaAllergies,
  FaBreadSlice,
  FaTint,
} from "react-icons/fa";

const ToggleButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.4rem;
  padding: 0.9rem;
  border: none;
  background: ${({ active }) =>
    active ? "var(--color-witron-blue)" : "var(--color-bg)"};
  border-radius: 0.6rem;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-btn);
  cursor: pointer;
  color: white;
  font-size: 1.8rem;
  width: 5.5rem;
  height: 5.5rem;

  &:hover {
    background: ${({ active }) => (active ? "#5b6eae" : "#aaa")};
  }

  span {
    font-size: 0.9rem;
    margin-top: 1.3rem;
    text-align: top;
  }
`;

const allergenIcons = {
  dairy: { label: "Dairy", icon: FaCheese },
  eggs: { label: "Eggs", icon: FaEgg },
  fish: { label: "Fish", icon: FaFish },
  soy: { label: "Soy", icon: FaSeedling },
  nuts: { label: "Nuts", icon: FaAllergies },
  gluten: { label: "Gluten", icon: FaBreadSlice },
  sesame: { label: "Sesame", icon: FaSeedling },
  shellfish: { label: "Shellfish", icon: FaFish },
  sulphites: { label: "Sulphites", icon: FaTint },
  mustard: { label: "Mustard", icon: FaSeedling },
};

function AllergenToggle({ name, control }) {
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const allergen = allergenIcons[name];
  if (!allergen) return null;

  const Icon = allergen.icon;

  return (
    <ToggleButton type="button" active={value} onClick={() => onChange(!value)}>
      <Icon />
      <span>{allergen.label}</span>
    </ToggleButton>
  );
}

export default AllergenToggle;
